import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  alt: string;
  slug: string;
}

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  return (
    <article className="bg-card rounded-lg overflow-hidden shadow-subtle hover:shadow-brand-elevated transition-brand-complex group">
      <Link href={`/blog/${post.slug}`} className="block">
        <div className="relative h-48 overflow-hidden">
          <AppImage
            src={post.image}
            alt={post.alt}
            className="w-full h-full object-cover group-hover:scale-105 transition-brand-complex"
          />
          <div className="absolute top-4 left-4">
            <span className="inline-block px-3 py-1 bg-accent text-accent-foreground text-sm font-body font-medium rounded-full shadow-brand">
              {post.category}
            </span>
          </div>
        </div>

        <div className="p-6">
          <h3 className="font-headline font-semibold text-xl text-foreground mb-3 group-hover:text-primary transition-brand line-clamp-2">
            {post.title}
          </h3>

          <p className="font-body text-muted-foreground mb-4 line-clamp-3">
            {post.excerpt}
          </p>

          <div className="flex items-center justify-between text-sm text-muted-foreground font-body">
            <div className="flex items-center space-x-4">
              <span className="flex items-center">
                <Icon name="UserIcon" size={16} className="mr-1" />
                {post.author}
              </span>
              <span className="flex items-center">
                <Icon name="ClockIcon" size={16} className="mr-1" />
                {post.readTime}
              </span>
            </div>
            <span className="flex items-center">
              <Icon name="CalendarIcon" size={16} className="mr-1" />
              {post.date}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;